import { useState, useEffect } from 'react'
import DashboardMultiSelect from '../../../GlobalComponents/_misc/DashboardMultiSelect'
import { fetchVendorData, Vendors } from '../../../features/inventory/inventoryAPI'

interface VendorMultiSelectProps {
    selectedValues: Vendors
    onSelectedValuesChanged(selectedValues: Vendors): void
}

const VendorMultiSelect = (props: VendorMultiSelectProps) => {
    const [data, setData] = useState<Vendors>([])
    const [selectedValues, setSelectedValues] = useState<Vendors>(props.selectedValues)

    useEffect(() => {
        async function getVendorData() {
            let vendData: Vendors = await fetchVendorData()
            if (vendData) setData(vendData)
        }
        getVendorData()
    }, [])

    const onChange = (value: Vendors) => {
        setSelectedValues(value)
        props.onSelectedValuesChanged(value)
    }

    return (
        <DashboardMultiSelect
            data={data}
            keyField="VendorID"
            textField="VendorIDName"
            selectedValues={selectedValues}
            onSelectedValuesChanged={onChange}
        />
    )
}

export default VendorMultiSelect
